const OKReferenceLineLabel = require('okCharts/OKReferenceLineLabel/OKReferenceLineLabel');

export default OKReferenceLineLabel;